// import React, { useState } from 'react';

// const App = () => {
//   const [activeTab, setActiveTab] = useState('accueil');
//   const [formData, setFormData] = useState({
//     nom: '',
//     email: '',
//     telephone: '',
//     message: ''
//   });

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({
//       ...formData,
//       [name]: value
//     });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     // Logique d'envoi du formulaire
//     console.log('Formulaire soumis:', formData);
//     // Réinitialiser le formulaire
//     setFormData({
//       nom: '',
//       email: '',
//       telephone: '',
//       message: ''
//     });
//   };

//   return (
//     <div className="min-h-screen bg-white">
//       {/* Header */}
//       <header className="bg-[#2D2A5D] text-white">
//         <div className="container mx-auto px-4 py-4 flex flex-col md:flex-row items-center justify-between">
//           <div className="flex items-center mb-4 md:mb-0">
//             <div className="text-4xl font-bold tracking-tighter">
//               <span className="text-white">EDMF</span>
//             </div>
//             <div className="ml-2 text-sm">
//               <div>Ets Doudou MENDY & FILS</div>
//             </div>
//           </div>
//           <nav className="flex items-center space-x-6">
//             <button
//               onClick={() => setActiveTab('accueil')}
//               className={`text-white hover:text-red-500 transition-colors cursor-pointer whitespace-nowrap ${activeTab === 'accueil' ? 'border-b-2 border-red-500' : ''}`}
//             >
//               Accueil
//             </button>
//             <button
//               onClick={() => setActiveTab('services')}
//               className={`text-white hover:text-red-500 transition-colors cursor-pointer whitespace-nowrap ${activeTab === 'services' ? 'border-b-2 border-red-500' : ''}`}
//             >
//               Services
//             </button>
//             <a 
//               href="https://readdy.ai/home/f07377b7-5749-4166-bc69-c2dae436c428/61e439fc-d4ff-46a4-a32b-a92d4fab25ee" 
//               data-readdy="true"
//               onClick={() => setActiveTab('realisations')}
//               className={`text-white hover:text-red-500 transition-colors cursor-pointer whitespace-nowrap ${activeTab === 'realisations' ? 'border-b-2 border-red-500' : ''}`}
//             >
//               Réalisations
//             </a>
//             <button
//               onClick={() => setActiveTab('apropos')}
//               className={`text-white hover:text-red-500 transition-colors cursor-pointer whitespace-nowrap ${activeTab === 'apropos' ? 'border-b-2 border-red-500' : ''}`}
//             >
//               À Propos
//             </button>
//             <button
//               onClick={() => setActiveTab('contact')}
//               className={`bg-red-600 hover:bg-red-700 px-4 py-2 rounded-lg text-white font-medium transition-colors cursor-pointer !rounded-button whitespace-nowrap`}
//             >
//               Contact
//             </button>
//           </nav>
//         </div>
//         <div className="bg-red-600 py-2">
//           <div className="container mx-auto px-4 flex justify-center md:justify-between flex-wrap">
//             <div className="text-white text-center md:text-left">
//               <span className="mx-2 whitespace-nowrap">ENTRETIEN BATIMENT</span>
//               <span className="mx-2 whitespace-nowrap">•</span>
//               <span className="mx-2 whitespace-nowrap">PEINTURE</span>
//               <span className="mx-2 whitespace-nowrap">•</span>
//               <span className="mx-2 whitespace-nowrap">MACONNERIE</span>
//               <span className="mx-2 whitespace-nowrap">•</span>
//               <span className="mx-2 whitespace-nowrap">ELECTRICITE</span>
//               <span className="mx-2 whitespace-nowrap">•</span>
//               <span className="mx-2 whitespace-nowrap">ETANCHEITE</span>
//               <span className="mx-2 whitespace-nowrap">•</span>
//               <span className="mx-2 whitespace-nowrap">CHARPENTE</span>
//             </div>
//           </div>
//         </div>
//       </header>

//       {/* Hero Section */}
//       <section className="relative h-[600px] overflow-hidden">
//         <div
//           className="absolute inset-0 bg-cover bg-center"
//           style={{
//             backgroundImage: `url('https://public.readdy.ai/ai/img_res/8e4c05e1ada20683a710a4a85d3bf671.jpg')`
//           }}
//         >
//           <div className="absolute inset-0 bg-gradient-to-r from-[#2D2A5D]/90 to-transparent"></div>
//         </div>
//         <div className="container mx-auto px-4 h-full flex items-center relative z-10">
//           <div className="max-w-2xl text-white">
//             <h1 className="text-4xl md:text-5xl font-bold mb-4">Solutions professionnelles pour tous vos projets de bâtiment</h1>
//             <p className="text-lg mb-8">Expertise en peinture, maçonnerie, électricité et plus encore. Qualité et savoir-faire depuis plus de 15 ans.</p>
//             <div className="flex flex-wrap gap-4">
//               <button className="bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-lg font-medium transition-colors cursor-pointer !rounded-button whitespace-nowrap">
//                 Nos Services
//               </button>
//               <button className="bg-white hover:bg-gray-100 text-[#2D2A5D] px-6 py-3 rounded-lg font-medium transition-colors cursor-pointer !rounded-button whitespace-nowrap">
//                 Demander un Devis
//               </button>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Services Section */}
//       <section className="py-16 bg-gray-50">
//         <div className="container mx-auto px-4">
//           <div className="text-center mb-12">
//             <h2 className="text-3xl font-bold text-[#2D2A5D] mb-2">Nos Services</h2>
//             <p className="text-gray-600 max-w-2xl mx-auto">Découvrez notre gamme complète de services professionnels pour répondre à tous vos besoins en matière de construction et rénovation.</p>
//           </div>
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//             {/* Service 1 */}
//             <div className="bg-white rounded-lg shadow-md overflow-hidden transition-transform hover:scale-105">
//               <div className="h-48 overflow-hidden">
//                 <img
//                   src="https://public.readdy.ai/ai/img_res/90bdb003737faa3e753b5261b5dfee1d.jpg"
//                   alt="Service de peinture"
//                   className="w-full h-full object-cover object-top"
//                 />
//               </div>
//               <div className="p-6">
//                 <div className="flex items-center mb-3">
//                   <i className="fas fa-paint-roller text-red-600 text-xl mr-3"></i>
//                   <h3 className="text-xl font-semibold text-[#2D2A5D]">Peinture</h3>
//                 </div>
//                 <p className="text-gray-600 mb-4">Services de peinture intérieure et extérieure avec des finitions de haute qualité pour tous types de surfaces.</p>
//                 <button className="text-red-600 hover:text-red-700 font-medium flex items-center cursor-pointer whitespace-nowrap">
//                   {/* En savoir plus <i className="fas fa-arrow-right ml-2"></i> */}
//                 </button>
//               </div>
//             </div>
//             <div className="bg-white rounded-lg shadow-md overflow-hidden transition-transform hover:scale-105">
//               <div className="h-48 overflow-hidden">
//                 <img
//                   src="https://public.readdy.ai/ai/img_res/0bf85369f77971d7b24881f58a356b22.jpg"
//                   alt="Service de maçonnerie"
//                   className="w-full h-full object-cover object-top"
//                 />
//               </div>
//               <div className="p-6">
//                 <div className="flex items-center mb-3">
//                   <i className="fas fa-hard-hat text-red-600 text-xl mr-3"></i>
//                   <h3 className="text-xl font-semibold text-[#2D2A5D]">Maçonnerie</h3>
//                 </div>
//                 <p className="text-gray-600 mb-4">Travaux de maçonnerie générale, construction de murs,
//                 fondations et structures en béton armé.</p>
//                 <button className="text-red-600 hover:text-red-700 font-medium flex items-center cursor-pointer whitespace-nowrap">
//                   {/* En savoir plus <i className="fas fa-arrow-right ml-2"></i> */}
//                 </button>
//               </div>
//             </div>
//             <div className="bg-white rounded-lg shadow-md overflow-hidden transition-transform hover:scale-105">
//               <div className="h-48 overflow-hidden">
//                 <img
//                   src="https://public.readdy.ai/ai/img_res/7a32d354b042163d7dbfbb83550c23d3.jpg"
//                   alt="Service d'étanchéité"
//                   className="w-full h-full object-cover object-top"
//                 />
//               </div>
//               <div className="p-6">
//                 <div className="flex items-center mb-3">
//                   <i className="fas fa-tint-slash text-red-600 text-xl mr-3"></i>
//                   <h3 className="text-xl font-semibold text-[#2D2A5D]">Étanchéité</h3>
//                 </div>
//                 <p className="text-gray-600 mb-4">Solutions d'étanchéité pour toitures, terrasses et fondations,
//                 avec garantie d'efficacité et de durabilité.</p>
//                 <button className="text-red-600 hover:text-red-700 font-medium flex items-center cursor-pointer whitespace-nowrap">
//                   {/* En savoir plus <i className="fas fa-arrow-right ml-2"></i> */}
//                 </button>
//               </div>
//             </div>
//           </div>
//           <div className="text-center mt-12">
//             <button className="bg-[#2D2A5D] hover:bg-[#1F1C45] text-white px-6 py-3 rounded-lg font-medium transition-colors cursor-pointer !rounded-button whitespace-nowrap">
//               Voir tous nos services
//             </button>
//           </div>
//         </div>
//       </section>

//       {/* Pourquoi nous choisir */}
//       <section className="py-16 bg-white">
//         <div className="container mx-auto px-4">
//           <div className="flex flex-col md:flex-row items-center">
//             <div className="md:w-1/2 mb-8 md:mb-0 md:pr-8">
//               <img
//                 src="https://public.readdy.ai/ai/img_res/660546d6e5f4379e5d0073fcf0678429.jpg"
//                 alt="Notre équipe"
//                 className="rounded-lg shadow-lg w-full h-auto"
//               />
//             </div>
//             <div className="md:w-1/2">
//               <h2 className="text-3xl font-bold text-[#2D2A5D] mb-4">Pourquoi choisir EDMF ?</h2>
//               <p className="text-gray-600 mb-6">Depuis plus de 15 ans, nous mettons notre expertise au service de vos projets de construction et de rénovation.</p>
//               <div className="space-y-4">
//                 <div className="flex items-start">
//                   <div className="bg-red-600 p-2 rounded-full text-white mr-4 mt-1">
//                     <i className="fas fa-check"></i>
//                   </div>
//                   <div>
//                     <h3 className="text-xl font-semibold text-[#2D2A5D] mb-1">Expertise professionnelle</h3>
//                     <p className="text-gray-600">Une équipe qualifiée avec des années d'expérience dans tous les domaines du bâtiment.</p>
//                   </div>
//                 </div>
//                 <div className="flex items-start">
//                   <div className="bg-red-600 p-2 rounded-full text-white mr-4 mt-1">
//                     <i className="fas fa-medal"></i>
//                   </div>
//                   <div>
//                     <h3 className="text-xl font-semibold text-[#2D2A5D] mb-1">Qualité garantie</h3>
//                     <p className="text-gray-600"> Nous nous engageons à fournir des prestations de haute
//                     qualité avec des matériaux sélectionnés.</p>
//                   </div>
//                 </div>
//                 <div className="flex items-start">
//                   <div className="bg-red-600 p-2 rounded-full text-white mr-4 mt-1">
//                     <i className="fas fa-clock"></i>
//                   </div>
//                   <div>
//                     <h3 className="text-xl font-semibold text-[#2D2A5D] mb-1">Respect des délais</h3>
//                     <p className="text-gray-600">Nous respectons scrupuleusement les délais convenus pour
//                     la réalisation de vos projets.</p>
//                   </div>
//                 </div>
//                 <div className="flex items-start">
//                   <div className="bg-red-600 p-2 rounded-full text-white mr-4 mt-1">
//                     <i className="fas fa-euro-sign"></i>
//                   </div>
//                   <div>
//                     <h3 className="text-xl font-semibold text-[#2D2A5D] mb-1">Tarifs compétitifs</h3>
//                     <p className="text-gray-600">Des prix justes et transparents adaptés à tous les budgets
//                     sans compromis sur la qualité.</p>
//                   </div>
//                 </div>
//                 {/* Ajoutez ici les autres avantages... */}
//               </div>
//               <button className="mt-8 bg-[#2D2A5D] hover:bg-[#1F1C45] text-white px-6 py-3 rounded-lg font-medium transition-colors cursor-pointer !rounded-button whitespace-nowrap">
//                 En savoir plus sur nous
//               </button>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Réalisations */}
//       <section className="py-16 bg-gray-50">
//         <div className="container mx-auto px-4">
//           <div className="text-center mb-12">
//             <h2 className="text-3xl font-bold text-[#2D2A5D] mb-2">Nos Réalisations</h2>
//             <p className="text-gray-600 max-w-2xl mx-auto">Découvrez quelques-uns de nos projets récents qui témoignent de notre savoir-faire et de notre expertise.</p>
//           </div>
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//             {/* Projet 1 */}
//             <div className="bg-white rounded-lg shadow-md overflow-hidden">
//               <div className="h-64 overflow-hidden">
//                 <img
//                   src="https://public.readdy.ai/ai/img_res/d04d319a2459401a783ec6d89fcc3fed.jpg"
//                   alt="Rénovation appartement"
//                   className="w-full h-full object-cover object-top transition-transform hover:scale-110 cursor-pointer"
//                 />
//               </div>
//               <div className="p-6">
//                 <h3 className="text-xl font-semibold text-[#2D2A5D] mb-2">Rénovation complète d'un appartement</h3>
//                 <p className="text-gray-600 mb-3">Peinture, électricité et maçonnerie pour la transformation d'un appartement ancien.</p>
//                 <div className="flex items-center text-sm text-gray-500">
//                   <i className="fas fa-map-marker-alt mr-2 text-red-600"></i>
//                   <span>Paris 15ème</span>
//                 </div>
//               </div>
//             </div>
//             <div className="bg-white rounded-lg shadow-md overflow-hidden">
//               <div className="h-64 overflow-hidden">
//                 <img
//                   src="https://public.readdy.ai/ai/img_res/e0156d2f8515e2dca61a58ffea6f533f.jpg"
//                   alt="Étanchéité toiture"
//                   className="w-full h-full object-cover object-top transition-transform hover:scale-110 cursor-pointer"
//                 />
//               </div>
//               <div className="p-6">
//                 <h3 className="text-xl font-semibold text-[#2D2A5D] mb-2">Étanchéité toiture terrasse</h3>
//                 <p className="text-gray-600 mb-3">Réfection complète de l'étanchéité d'une toiture terrasse de
//                 120m².</p>
//                 <div className="flex items-center text-sm text-gray-500">
//                   <i className="fas fa-map-marker-alt mr-2 text-red-600"></i>
//                   <span>Paris 15ème</span>
//                 </div>
//               </div>
//             </div>
//             <div className="bg-white rounded-lg shadow-md overflow-hidden">
//               <div className="h-64 overflow-hidden">
//                 <img
//                   src="https://public.readdy.ai/ai/img_res/653a679efcf429249f7f8631f138f39a.jpg"
//                   alt="Installation électrique"
//                   className="w-full h-full object-cover object-top transition-transform hover:scale-110 cursor-pointer"
//                 />
//               </div>
//               <div className="p-6">
//                 <h3 className="text-xl font-semibold text-[#2D2A5D] mb-2">Installation électrique complète</h3>
//                 <p className="text-gray-600 mb-3">Mise aux normes et installation électrique pour des bureaux
//                   professionnels.
//                 </p>
//                 <div className="flex items-center text-sm text-gray-500">
//                   <i className="fas fa-map-marker-alt mr-2 text-red-600"></i>
//                   <span>Paris 15ème</span>
//                 </div>
//               </div>
//             </div>
//             {/* Ajoutez ici les autres réalisations... */}
//           </div>
//           <div className="text-center mt-12">
//             <button className="bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-lg font-medium transition-colors cursor-pointer !rounded-button whitespace-nowrap">
//               Voir toutes nos réalisations
//             </button>
//           </div>
//         </div>
//       </section>

//       {/* Formulaire de contact */}
//       <section className="py-16 bg-white">
//         <div className="container mx-auto px-4">
//           <div className="flex flex-col lg:flex-row">
//             <div className="lg:w-1/2 lg:pr-12 mb-10 lg:mb-0">
//               <h2 className="text-3xl font-bold text-[#2D2A5D] mb-4">Contactez-nous</h2>
//               <p className="text-gray-600 mb-8">Vous avez un projet en tête ? N'hésitez pas à nous contacter pour obtenir un devis gratuit ou pour toute information complémentaire.</p>
//               <div className="space-y-6">
//                 {/* Informations de contact */}
//                 <div className="flex items-start">
//                   <div className="bg-[#2D2A5D] p-3 rounded-full text-white mr-4">
//                     <i className="fas fa-map-marker-alt"></i>
//                   </div>
//                   <div>
//                     <h3 className="text-xl font-semibold text-[#2D2A5D] mb-1">
//                       Adresse
//                     </h3>
//                     <p className="text-gray-600">
//                       123 Avenue des Bâtisseurs, 75001 Paris
//                     </p>
//                   </div>
//                 </div>
//                 <div className="flex items-start">
//                   <div className="bg-[#2D2A5D] p-3 rounded-full text-white mr-4">
//                     <i className="fas fa-phone-alt"></i>
//                   </div>
//                   <div>
//                     <h3 className="text-xl font-semibold text-[#2D2A5D] mb-1">
//                       Téléphone
//                     </h3>
//                     <p className="text-gray-600">+33 1 23 45 67 89</p>
//                   </div>
//                 </div>
//                 <div className="flex items-start">
//                   <div className="bg-[#2D2A5D] p-3 rounded-full text-white mr-4">
//                     <i className="fas fa-envelope"></i>
//                   </div>
//                   <div>
//                     <h3 className="text-xl font-semibold text-[#2D2A5D] mb-1">
//                       Email
//                     </h3>
//                     <p className="text-gray-600">contact@edmf.fr</p>
//                   </div>
//                 </div>
//                 <div className="flex items-start">
//                   <div className="bg-[#2D2A5D] p-3 rounded-full text-white mr-4">
//                     <i className="fas fa-clock"></i>
//                   </div>
//                   <div>
//                     <h3 className="text-xl font-semibold text-[#2D2A5D] mb-1">
//                       Horaires
//                     </h3>
//                     <p className="text-gray-600">
//                       Lundi - Vendredi: 8h00 - 18h00
//                     </p>
//                     <p className="text-gray-600">Samedi: 9h00 - 12h00</p>
//                   </div>
//                 </div>
//               </div>
//               <div className="mt-8">
//                 <h3 className="text-xl font-semibold text-[#2D2A5D] mb-3">
//                   Suivez-nous
//                 </h3>
//                 <div className="flex space-x-4">
//                   <a
//                     href="#"
//                     className="bg-[#2D2A5D] hover:bg-[#1F1C45] text-white p-3 rounded-full transition-colors cursor-pointer"
//                   >
//                     <i className="fab fa-facebook-f"></i>
//                   </a>
//                   <a
//                     href="#"
//                     className="bg-[#2D2A5D] hover:bg-[#1F1C45] text-white p-3 rounded-full transition-colors cursor-pointer"
//                   >
//                     <i className="fab fa-instagram"></i>
//                   </a>
//                   <a
//                     href="#"
//                     className="bg-[#2D2A5D] hover:bg-[#1F1C45] text-white p-3 rounded-full transition-colors cursor-pointer"
//                   >
//                     <i className="fab fa-linkedin-in"></i>
//                   </a>
//                 </div>
//               </div>
//             </div>
//             <div className="lg:w-1/2 bg-gray-50 rounded-lg p-8 shadow-md">
//               <h3 className="text-2xl font-semibold text-[#2D2A5D] mb-6">Envoyez-nous un message</h3>
//               <form onSubmit={handleSubmit}>
//                 <div className="mb-4">
//                   <label htmlFor="nom" className="block text-gray-700 font-medium mb-2">Nom complet</label>
//                   <input
//                     type="text"
//                     id="nom"
//                     name="nom"
//                     value={formData.nom}
//                     onChange={handleInputChange}
//                     className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#2D2A5D]"
//                     placeholder="Votre nom"
//                     required
//                   />
//                 </div>
//                 <div className="mb-4">
//                   <label htmlFor="email" className="block text-gray-700 font-medium mb-2">Email</label>
//                   <input
//                     type="email"
//                     id="email"
//                     name="email"
//                     value={formData.email}
//                     onChange={handleInputChange}
//                     className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#2D2A5D]"
//                     placeholder="Votre email"
//                     required
//                   />
//                 </div>
//                 <div className="mb-4">
//                   <label htmlFor="telephone" className="block text-gray-700 font-medium mb-2">Téléphone</label>
//                   <input
//                     type="tel"
//                     id="telephone"
//                     name="telephone"
//                     value={formData.telephone}
//                     onChange={handleInputChange}
//                     className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#2D2A5D]"
//                     placeholder="Votre numéro de téléphone"
//                   />
//                 </div>
//                 <div className="mb-6">
//                   <label htmlFor="message" className="block text-gray-700 font-medium mb-2">Message</label>
//                   <textarea
//                     id="message"
//                     name="message"
//                     value={formData.message}
//                     onChange={handleInputChange}
//                     rows={5}
//                     className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#2D2A5D]"
//                     placeholder="Décrivez votre projet ou votre demande"
//                     required
//                   ></textarea>
//                 </div>
//                 <button
//                   type="submit"
//                   className="w-full bg-red-600 hover:bg-red-700 text-white font-medium py-3 rounded-lg transition-colors cursor-pointer !rounded-button whitespace-nowrap"
//                 >
//                   Envoyer le message
//                 </button>
//               </form>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Footer */}
//       <footer className="bg-[#2D2A5D] text-white pt-12 pb-6">
//         <div className="container mx-auto px-4">
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
//             {/* Sections du footer */}
//           </div>
//           <div className="pt-8 border-t border-gray-700 text-center text-sm">
//             <p>&copy; {new Date().getFullYear()} EDMF - Ets Doudou MENDY & FILS. Tous droits réservés.</p>
//             <div className="flex justify-center space-x-4 mt-4">
//               <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Mentions légales</a>
//               <span className="text-gray-500">|</span>
//               <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Politique de confidentialité</a>
//             </div>
//             <div className="flex justify-center space-x-4 mt-4">
//               <i className="fab fa-cc-visa text-2xl"></i>
//               <i className="fab fa-cc-mastercard text-2xl"></i>
//               <i className="fab fa-cc-paypal text-2xl"></i>
//             </div>
//           </div>
//         </div>
//       </footer>
//     </div>
//   );
// };

// export default App;


import React, { useState } from 'react';
import Header from './components/Header';
import Home from './components/Home';
import Footer from './components/Footer';
import About from './components/About';
import Services from './components/Services';
import Realisations from './components/Realisations';
import ScrollToTop from './utils/ScrollToTop';
import { Route, Routes } from 'react-router-dom';


const App = () => {
  const [activeTab, setActiveTab] = useState('accueil');

  return (
      <div className="min-h-screen bg-white">
        <ScrollToTop />
        <Header activeTab={activeTab} setActiveTab={setActiveTab} />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about" element={<About />} />
          <Route path="/realisations" element={<Realisations />} />
        </Routes>
        <Footer />
      </div>
  );
};

export default App;